import React from 'react'
import {
  PatternFormat as ReactPatternFormat,
  PatternFormatProps as ReactPatternFormatProps,
} from 'react-number-format'

type TPickedProp =
  | 'displayType'
  | 'value'
  | 'mask'
  | 'placeholder'
  | 'type'
  | 'onChange'
  | 'disabled'
  | 'name'
  | 'onValueChange'
  | 'aria-label'
  | 'id'
  | 'className'
  | 'onBlur'

export interface IPatternFormatProps extends Partial<Pick<ReactPatternFormatProps, TPickedProp>> {
  'data-test'?: string
  format: ReactPatternFormatProps['format']
}

const PatternFormat = (props: IPatternFormatProps) => {
  return <ReactPatternFormat {...props} />
}

export default PatternFormat
